<template>
    <div class="sensors-wrapper container">
        <b-row v-if="anySensors">
            <b-col cols="12" class="meters-title-section-title">
                <span>{{ $t('dashboard.sensors') }}:</span>
            </b-col>
        </b-row>
        <b-row class="sidebar-meters-list level-meters"
               v-if="getDamLevelmeters[1].length !== 0"
        >
            <b-col cols="12" class="blue-sensor-name">
                <span>{{ $t('dashboard.levelmeters') }}</span>
            </b-col>
            <b-col cols="12" class="panel-meter-info-listing">
                <RightPanelContainerSensor
                    v-for="(key, index) in getDamLevelmeters[1]"
                    :meter-name="key"
                    :meter-value="getValueOrDefault(getDamLevelmeters[0][key][1])"
                    :meter-metric="safeGetMetric(key)"
                    :meter-date="getLastUpdatedValue(key)"
                    :key="`lm${index}`"
                ></RightPanelContainerSensor>
            </b-col>
        </b-row>
        <b-row class="row sidebar-meters-list piezometers"
               v-if="getDamPiezometers[1].length !== 0"
        >
            <b-col cols="12" class="blue-sensor-name">
                <span>{{ $t('dashboard.piezometer') }}</span>
            </b-col>
            <b-col cols="12" class="panel-meter-info-listing">
                <RightPanelContainerSensor
                    v-for="(key, index) in getDamPiezometers[1]"
                    :meter-name="key"
                    :meter-value="getValueOrDefault(getDamPiezometers[0][key])"
                    :meter-metric="safeGetMetric(key)"
                    :meter-date="getLastUpdatedValue(key)"
                    :key="`pz${index}`"
                ></RightPanelContainerSensor>
            </b-col>
        </b-row>
        <b-row class="sidebar-meters-list inclinometers"
                   v-if="getDamInclinometersNew"
            >
            <b-col cols="12" class="blue-sensor-name">
                <span>{{ $t('dashboard.inclinometers') }}</span>
            </b-col>
            <b-col cols="6">
                <span class="panel-subtitle">Elevation (m)</span>
            </b-col>
            <b-col class="text-right" cols="6">
                <span class="panel-subtitle">X/Y Δ {{getDamInclinometersNew.delta}} days (mm/m)</span>
            </b-col>
            <b-col>

            </b-col>
            <b-col cols="12" class="panel-meter-info-listing pb-0">
                <RightPanelContainerSensorInclinometer
                    v-for="(inclinometer, index) in getDamInclinometersNew.data"
                    :meter-name="inclinometer[0]"
                    :meter-value="getInclinometerValue(inclinometer)"
                    :meter-metric="safeGetMetric(inclinometerStr)"
                    :index="index"
                    :key="`im${index}`"
                ></RightPanelContainerSensorInclinometer>
            </b-col>
            <b-col cols="12" class="pt-0"><span class="panel-subtitle">Actualized: {{getLastUpdatedValue('Inclinometer')}}</span></b-col>  
        </b-row>
    </div>
</template>

<script>
    // utils, vuex
    import {iconsUnits} from "../../constants/sensors-constants";
    import {mapGetters} from "vuex";
    import {formatDate, parsedDate} from "../../utils/common";
    // components
    import RightPanelContainerSensor from "./RightPanelContainerSensor";
    import RightPanelContainerSensorInclinometer from "./RightPanelContainerSensorInclinometer";


    /**
     * Lists the different kinds of meters in a normalized fashion.
     */

    export default {
        name: "RightPanelContainerSensorsList",
        components: {
            RightPanelContainerSensor,
            RightPanelContainerSensorInclinometer
        },
        data() {
            return {
                iconsUnits,
                inclinometerStr: "Inclinometer"
            }
        },
        computed: {
            ...mapGetters(['getDamPiezometers', 'getDamInclinometers', 'getDamInclinometersNew', 'getDamLevelmeters', 'getLastUpdatedObj']),
            anySensors() {
                const piezometersLen = this.getDamPiezometers[1].length;
                const inclinometersLen = this.getDamInclinometersNew;
                const levelmeterLen = this.getDamLevelmeters[1].length;

                return piezometersLen !== 0 || inclinometersLen !== 0 || levelmeterLen !== 0;
            }
        },
        methods: {

            /**
             * Round and format inclinometer values.
             * Values used are in mm. Only those are supplied.
             * @param {string} key: Inclinometer name (Inclinometer + index)
             * @returns {string}
             */
            getInclinometerValue(key) {
                const notFound = '-';
                const valueOne = this.getValueOrDefault(key[1]);
                const valueTwo = this.getValueOrDefault(key[2]);

                let parsedValueOne = '-';
                let parsedValueTwo = '-';

                if (valueOne !== notFound) {
                    parsedValueOne = parseFloat(valueOne).toFixed(2);
                }
                if (valueTwo !== notFound) {
                    parsedValueTwo = parseFloat(valueTwo).toFixed(2);
                }

                return `${parsedValueOne}/${parsedValueTwo}`;
            },
            /**
             * Check if value is valid, even if false like (zero is ok value).
             * @param {string} value
             */
            getValueOrDefault(value) {
                const notFoundDefaultStr = '-';

                if (value !== null && value !== '' && value !== undefined) {
                    return value;
                } else {
                    return notFoundDefaultStr;
                }
            },
            getLastUpdatedValue(key) {
                let formattedDate = this.$i18n.t('dashboard.not-applicable');
                try {
                    const strValue = this.getLastUpdatedObj[key];
                    if (strValue) {
                        const lastUpdatedAsDate =  parsedDate(strValue);
                        formattedDate = formatDate(lastUpdatedAsDate);
                    }
                } catch (e) {
                    // ignore
                }
                return formattedDate;
            },
            safeGetMetric(key) {
                let metric = '';
                try {
                    if (this.iconsUnits?.[key] && this.$i18n.te(this.iconsUnits[key].unit)) {
                        metric = this.$i18n.t(this.iconsUnits[key].unit);
                    }
                }
                catch (e) {
                    // show us if there is something missing
                    console.error("Code: MUK-RPCSL-1");
                }
                return metric;
            },
            /**
             * This should extract all the digits from a string
             * and return as is.
             * @param inclinometerName
             * @returns {string} the index
             */
            extractIndexFromName(inclinometerName) {
                let indexFromName = '';

                if (inclinometerName) {
                    let digitsArr = inclinometerName.match(/\d/g);
                    if (digitsArr) {
                        indexFromName = digitsArr.join('');
                    }
                }

                return  indexFromName;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";
    /* ********************* sensors list ******************** */

    .meters-title-section-title {
        text-align: left;
        font: 400 14px/19px Nunito, sans-serif;
        letter-spacing: 0;
        color: #000000;
        opacity: 1;
        padding-top: 1rem;
        padding-bottom: 0.5rem;
    }

    .sensors-wrapper {
        flex-grow: 1;
        overflow-y: auto;
        min-height: 0;
        width: 100%;
        padding-left: 0;
    }

    .sidebar-meters-list {
        border-bottom: 1px solid #CDCDCD;

        .blue-sensor-name {
            text-align: left;
            font: 600 16px/14px Nunito, sans-serif;
            letter-spacing: 0px;
            color: #6299EB;
            opacity: 1;
        }

        > .col-12 {
            padding-top: 9px;
            padding-bottom: 9px;
        }
    }
    .panel-subtitle {
        text-align: left;
        font: 300 12px/14px Nunito, sans-serif;
        letter-spacing: 0px;
        color: #909090;
        opacity: 1;
    }
</style>
